module.exports = __webpack_public_path__ + "static/media/skeletonSax.48b053be.gif";